 <div class="card card-nav-tabs rounded-lg border-0 mt-3">
    <p class="p-3 mb-1 text-x fw-bold">Payments History Overview</p>

    <div class="card-body mt-0">
      <!-- Loader -->
      <div v-if="loading" class="text-center py-4 text-muted">
        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
        Loading payment history...
      </div>

      <!-- Table if data exists -->
      <div v-else-if="payment_history.length">
        <GlobalTable
          :headers="['Payment Date', 'Amount', 'Reference', 'Document']"
          :data="payment_history"
          table_id="payment_history"
        >
          <!-- Preview button -->
          <template #actions="{ row }">
            <button
              class="btn btn-primary-dark btn-sm text-xxs"
              @click="preview_proof(row)"
              data-bs-toggle="modal"
              data-bs-target="#proof_preview_modal"
            >
              Preview
            </button>
          </template>

          <!-- Clickable Document column -->
          <template #cell-Document="{ row }">
            <a
              href="javascript:void(0)"
              @click="open_document(row)"
              class="text-primary text-decoration-underline"
            >
              {{ row.Document }}
            </a>
          </template>
        </GlobalTable>
      </div>

      <!-- No records message -->
      <div v-else class="alert alert-info text-xxs mt-3">
        <i class="bi bi-info-circle-fill me-2"></i>
        No payment history available.
      </div>
    </div>
  </div>

  <!-- Proof Preview Modal -->
   <teleport to="body">
  <div
    class="modal fade"
    id="proof_preview_modal"
    tabindex="-1"
    aria-labelledby="proofPreviewModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
      <div class="modal-content bg-white rounded-3 p-0 shadow-lg">
        <div class="modal-header border-bottom-0 cute-header shadow-lg">
          <h5 class="modal-title text-white text-xxs" id="proofPreviewModalLabel">
            Preview Proof of Payment
          </h5>
          <button
            type="button"
            class="modal-btn-close btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="ratio ratio-4x3">
            <iframe
              v-if="current_proof_url"
              :src="current_proof_url"
              frameborder="0"
              width="100%"
              height="100%"
            ></iframe>
            <div
              v-else
              class="d-flex align-items-center justify-content-center w-100 h-100"
            >
              No preview available.
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </teleport>